<template>
  <div class="playlist-track-adding">
    <Modal v-if="open" class="mk-modal" @close="close">
      <slot>
        <div class="add-title">
          {{ $t('TRACK.ADD_TO_PLAYLIST') }}
        </div>
        <div class="adding-loader">
          <Loader :loading="loading" />
        </div>
        <div v-show="!loading">
          <a class="add-to-new-list" @click="addToNewList">
            <div class="add-btn">
              <i class="material-icons">
                add
              </i>
            </div>
            <div class="text">
              {{ $t('PLAYLIST.NEW_PLAYLIST') }}
            </div>
          </a>
          <div class="current-list">
            <div v-for="playlist in playlists" :key="playlist.id" class="playlist-wrapper">
              <a
                v-if="(!skipPlaylist) || (skipPlaylist.id && playlist.id !== skipPlaylist.id)"
                class="playlist"
                @click="addToExistList(playlist.id)"
              >
                <div :style="coverBackgroundImage(playlist)" class="cover">
                  <!--  -->
                </div>
                <div class="text">
                  {{ playlist.title }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import Loader from '@/components/common/Loader'
import PlaylistService from '@/assets/services/PlaylistService'
import ImgLoader from '@/directives/ImgLoader'
import { displayTrackName } from '@/assets/helpers/TrackHelper'

export default {
  name: 'PlaylistTrackAddingModal',
  components: {
    Modal,
    Loader
  },
  directives: {
    ImgLoader
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedTrack: {
      type: Object,
      default: () => {}
    },
    skipPlaylist: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      playlists: undefined,
      loading: false
    }
  },
  computed: {
    profile() {
      return this.$store.state.user.profile
    }
  },
  watch: {
    open(newValue) {
      if (newValue) {
        this.getPlaylists()
      }
    }
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayTrackName,
    coverBackgroundImage(playlist) {
      return playlist && playlist['file_link'] ? { backgroundImage: `url(${playlist['file_link']})` } : {}
    },
    close() {
      this.$emit('close')
    },
    async getPlaylists() {
      this.loading = true
      const params = {
        q: {
          user_id: this.profile.id
        },
        per_page: 100,
        page: 1
      }
      const playlists = await PlaylistService.getPlaylists(params)
      if (playlists.data) {
        this.playlists = playlists.data
      }
      this.loading = false
    },
    async addToNewList() {
      this.loading = true
      const token = window.localStorage.getItem(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
      const data = {
        title: this.displayTrackName(this.selectedTrack)
      }
      const newPlaylist = await PlaylistService.createPlaylist(token, data)
      if (newPlaylist) {
        this.addToExistList(newPlaylist.id)
        this.$store.dispatch('UPDATE_USER_PLAYLIST')
      } else {
        this.$store.commit('ALERT_MESSAGE', { message: 'TRACK.ADD_TO_PLAYLIST_ERROR', type: 'error' })
        this.loading = false
      }
    },
    async addToExistList(playlistId) {
      if (this.selectedTrack.id && playlistId) {
        this.loading = true
        const tracksAry = [this.selectedTrack.id]
        const res = await PlaylistService.addTracksToPlaylist(tracksAry, playlistId)
        this.loading = false
        if (res) {
          this.$store.commit('ALERT_MESSAGE', { message: 'TRACK.ADD_TO_PLAYLIST_SUCCESS', type: 'success' })
          await this.$store.dispatch('UPDATE_USER_PLAYLIST')
          this.$emit('close')
        } else {
          this.$store.commit('ALERT_MESSAGE', { message: 'TRACK.ADD_TO_PLAYLIST_ERROR', type: 'error' })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/variables.scss';

.playlist-track-adding {
  .adding-loader {
    display: block;
    text-align: center;
  }
  .add-title {
    display: block;
    margin-bottom: 24px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.63;
    color: $grey-50;
  }
  .text {
    position: relative;
    overflow: hidden;
    min-height: 48px;
    line-height: 48px;
    font-size: 20px;
    font-weight: 500;
    color: $grey-50;
  }
  .add-to-new-list {
    display: block;
    margin-bottom: 24px;
    cursor: pointer;
    .add-btn {
      float: left;
      width: 48px;
      height: 48px;
      line-height: 48px;
      margin-right: 16px;
      border-radius: 50%;
      color: #ffffff;
      background-color: $theme-yellow;
      text-align: center;
      > i {
        margin: 6px;
        line-height: 36px;
        font-size: 36px;
      }
    }
    &:hover {
      .text {
        color: $link-hover;
      }
    }
  }
  .current-list {
    .playlist {
      &-wrapper {
        margin-bottom: 24px;
        display: block;
      }
      display: inline-block; // for click area
      position: relative;
      overflow: hidden;
      cursor: pointer;

      .cover {
        position: relative;
        overflow: hidden;
        float: left;
        width: 48px;
        height: 48px;
        margin-right: 16px;
        border-radius: 12px;

        background-color: $grey-ec;
        background-image: url('/img/img-default/img-playlist-default-l.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        img {
          width: 48px;
          height: 48px;
          border-radius: 12px;
        }
      }
      &:hover {
        .text {
          color: $link-hover;
        }
      }
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}
@media only screen and (max-width: 767.98px) {
}
</style>
